import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/leave-management-system/leave-dashboard/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "leave-dashboard" entry is kept); the seo block below is a fallback.

export const leaveDashboard: ContentPage = {
  slug: "leave-management-system/leave-dashboard",
  template: "hrmsFeature",
  seo: {
    title: "Leave Dashboard - Real-Time Employee Leave Tracking",
    description: "Get a real-time view of employee leave with our Leave Dashboard. Monitor leave balances, requests, and approvals from a single, easy-to-use dashboard.",
    keywords: [
      "leave dashboard",
      "real-time leave tracking",
      "employee leave dashboard",
      "leave management dashboard",
      "HR leave tracking",
      "leave request overview",
    ],
    ogImage: "/assets/data/seoimages/leave-dashboard.webp",
  },
  leaf: {
    hero: {
      caption: "Leave Dashboard",
      title: "Get a Real-Time Overview with the Leave Management Dashboard",
      description: "Our Leave Dashboard provides a comprehensive, real-time view of employee leave, including balances, requests, and approvals. HR managers and employees can make informed decisions with an intuitive, easy-to-use interface.",
      h1: "caption",
    },
    split: {
      title: "Dynamic Leave Dashboard for Real-Time Insights",
      bullets: [
        { title: "Real-Time Data Display", description: "View real-time leave information including requests, balances, and approvals, ensuring accurate and current HR management." },
        { title: "Tailored User Views", description: "Managers see team-wide leave information, while employees access their own leave status, all from a unified interface." },
        { title: "Instant Leave Balance Summary", description: "Access up-to-date information on available and used leave to facilitate effective planning and decision-making." },
        { title: "Customizable Filters", description: "Apply filters to focus on specific leave types, departments, or time periods, making data analysis more precise." },
      ],
      image: "/assets/images/img/product/hrms/leavems/leave-dashboard_info.webp",
      imageAlt: "leave-dashboard_info",
    },
    cardsHeading: {
      title: "Key Features of Leave Management System",
      description: "Optimize leave management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Easy Approval",
        href: "/hrms-software/leave-management-system/leave-approval/",
        description: "Facilitate quick and easy leave request approvals or declines with a user-friendly workflow, keeping your HR processes efficient.",
        image: "/assets/images/img/product/hrms/leavems/easy_approval_decline.webp",
        imageAlt: "easy_approval",
      },
      {
        title: "Leave Policy & Allocation",
        href: "/hrms-software/leave-management-system/leave-policy-allocation",
        description: "Create and manage leave policies tailored to your organization’s needs. Allocate leaves based on roles, seniority, and more.",
        image: "/assets/images/img/product/hrms/leavems/leave_policy_and_allocation.webp",
        imageAlt: "leave_policy_and_allocation",
      },
      {
        title: "Leave Balance",
        href: "/hrms-software/leave-management-system/leave-balance",
        description: "Keep track of employee leave balances in real-time, ensuring transparency and accurate record-keeping.",
        image: "/assets/images/img/product/hrms/leavems/leave_balance_features.webp",
        imageAlt: "leave_balance",
      },
      {
        title: "Leave Accrual Details",
        href: "/hrms-software/leave-management-system/leave-accrual-details",
        description: "Automate the calculation of leave accruals to ensure accurate and fair leave tracking, eliminating manual errors.",
        image: "/assets/images/img/product/hrms/leavems/leave_accrual_details.webp",
        imageAlt: "leave_accrual_details",
      },
    ],
    testimonials: {
      title: "200+ Businesses across India love & trust us!",
      description: "Know why Superworks is the best HR software in India",
    },
    bookDemoTitle: "Empower Your HR Team with a Real-Time Leave Dashboard",
    relatedBlogsKeyword: "what-is-hrms,leave-management-software-sme",
    metaKey: "leave-dashboard",
  },
  sections: [],
};
